import { authHeader, utils } from "../helpers/"

const apiUrl = process.env.REACT_APP_API_URL

export const statsService = {
    getLatestContents,
    getStudentsLatestContents,
    getTopicStats,
    getStudentStats
}

function getLatestContents() {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    }

    return fetch(`${apiUrl}/api/latest-contents`, requestOptions)
        .then(utils.handleResponse)
        .then((data) => {
            return data
        })
        .catch((error) => Promise.reject(error))
}

function getStudentsLatestContents(studentId: string) {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    }

    return fetch(`${apiUrl}/api/students/${studentId}/latest-contents`, requestOptions)
        .then(utils.handleResponse)
        .then((data) => {
            return data
        })
        .catch((error) => Promise.reject(error))
}

export interface ApiCategoryStat {
    id: number;
    name: string;
    content_count: number;
    opened_count: number;
    solved_count: number;
    successfull_count: number;
}

export interface ApiTopicStat {
    id: number;
    name: string;
    content_count: number;
    opened_count: number;
    solved_count: number;
    successfull_count: number;
    categories: Record<string, ApiCategoryStat>;
}

export interface ApiLevelResponse {
    level: {
        id: number;
        name: string;
        content_count: number;
        topics: Record<string, ApiTopicStat>;
    };
}

function getTopicStats(level_id: string | number): Promise<ApiLevelResponse> {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    };

    return fetch(`${process.env.REACT_APP_API_URL}/api/stats?level_id=${level_id}`, requestOptions)
        .then(utils.handleResponse)
        .then((data) => {
            return data;
        });
}

function getStudentStats(level_id: string | number, student_id: string | number): Promise<ApiLevelResponse> {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    };

    return fetch(`${process.env.REACT_APP_API_URL}/api/student-stats/${student_id}?level_id=${level_id}`, requestOptions)
        .then(utils.handleResponse)
        .then((data) => {
            return data;
        });
}